module.exports = __webpack_public_path__ + "media/images/icons/icon-fabric-938e759bddae97d1a2a142bf43240760.svg";